// eslint-disable-next-line no-unused-vars

/** 
 * getUrlParam方法，获取url路径带的参数 
 * @param {String} name [获取的参数的name] 
 */
export function getUrlParam (name) {
  // eslint-disable-next-line no-sparse-arrays
  return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null
}

/**
 *animationScroll
 *执行滚动添加动画类
 * @export
 * @param {*} obj dom对象
 */
export function animationScroll(obj){
  $(window).scroll(function() {
    var Height = $(window).height();
    var Top = obj.offset().top; //元素距离顶部距离
    var scroll = $(document).scrollTop(); //滚动高度
    if (Top - Height - scroll <= 0) {
      obj.addClass("showAnimation");
    }
  });
}



// WEBPACK FOOTER //
// ./src/assets/js/common.js